import { render } from "./BaseSpinner.vue?vue&type=template&id=40f86d9f&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=40f86d9f&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f86d9f"]])

export default __exports__